<template>
  <b-container fluid>
        <b-row>
            <b-col cols="12" md="4">
                <div class="login__description">
                    <div>
                        <h3>
                            <img :src="$cdn + '/icons/icon-person-login.svg'" alt="icono persona">
                            Registro
                        </h3>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="8">
                <div class="login__form w-100 mb-0">
                    <div class="login__paragraph">
                        <p>Completa la siguiente información:</p>
                    </div>
                    <b-container fluid class="p-0">
                        <b-row>
                            <b-col cols='12' md='6'>
                                <div class="labels">
                                    <label for="tipoEmpresa">Tipo de empresa</label>
                                </div>
                                <div class="inputs mb-3">
                                    <b-form-select :options="tiposEmpresa" html-field="text" id="tipoEmpresa" v-model="tipoEmpresa"></b-form-select>
                                    <button class="boton-flecha">
                                        <img :src="$cdn + '/icons/icono-flecha-derecha-azul.svg'" alt="">
                                        <img :src="$cdn + '/icons/icono-flecha-derecha.svg'" alt="">
                                    </button>
                                </div>
                            </b-col>
                            <b-col cols='12' md='6'>
                                <div class="labels">
                                    <label for="nitEmpresa">NIT (Solo numeros sin DV)</label>
                                </div>
                                <div class="inputs mb-3">
                                    <input v-model="nitEmpresa" id="nitEmpresa" type="text" style="width: 80% !important;" @keypress="validateNumbers($event);" @keyup="calcularDig($event)">
                                    <input v-model="digitoVerificacion" id="digitoVerificacion" type="text" style="width: 15% !important; margin-left: 5%;" readonly>
                                </div>
                            </b-col>
                            <b-col cols='12' md='6'>
                                <div class="labels">
                                    <label for="nombreEmpresa">Nombre de la empresa</label>
                                </div>
                                <div class="inputs mb-3">
                                    <input v-model="nombreEmpresa" id="nombreEmpresa" type="text">
                                </div>
                            </b-col>
                            <b-col cols='12' md='6'>
                                <div class="labels">
                                    <label for="emailEmpresa">Email</label>
                                </div>
                                <div class="inputs mb-3">
                                    <input v-model="emailEmpresa" id="emailEmpresa" type="text">
                                </div>
                            </b-col>
                            <b-col cols='12' md='6'>
                                <div class="labels">
                                    <label for="representanteEmpresa">Nombre del representante legal</label>
                                </div>
                                <div class="inputs mb-3">
                                    <input v-model="representanteEmpresa" id="representanteEmpresa" type="text">
                                </div>
                            </b-col>
                            <b-col cols='12' md='6'>
                                <div class="labels">
                                    <label for="cedulaEmpresa">Cédula del representante legal</label>
                                </div>
                                <div class="inputs mb-3">
                                    <input v-model="cedulaEmpresa" id="cedulaEmpresa" type="text"  @keypress="validateNumbers($event);">
                                </div>
                            </b-col>
                            <b-col cols='12'>
                                <div class="labels">
                                    <label for="claveEmpresa">Escribe una contraseña</label>
                                </div>
                                <div class="inputs mb-3">
                                    <input v-model="claveEmpresa" id="claveEmpresa" type="password">
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
                <div class="login__form mt-5">
                    <button class="button-principal mb-5" @click="registrar">Registrarme</button>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
  name: 'formRegister',
  props: {
    datosIni: Object
  },
  mounted() {
    this.nitEmpresa = this.$props.datosIni.identificacion
    this.emailEmpresa = this.$props.datosIni.email
  },
  data () {
    return {
      tipoEmpresa: 1,
      tiposEmpresa: [
        { value: 1, text: 'Juridica (NIT)' },
        { value: 2, text: 'Natural (CC)' }
      ],
      nombreEmpresa: '',
      nitEmpresa: '',
      emailEmpresa: '',
      representanteEmpresa: '',
      cedulaEmpresa: '',
      claveEmpresa: '',
      digitoVerificacion: ''
    }
  },
  methods: {
    validardoc: function () {
      let resul = true
      let numbers = /^[-+]?[0-9]+$/;
      this.nitEmpresa = (''+this.nitEmpresa).match(numbers)
      if(isNaN(this.nitEmpresa)){
        resul = false
      }else{
        if((''+this.nitEmpresa).length>10){
          resul = false
        }
      }
      return resul
    },
    validateNumbers: function (evt) {
      let keyCode = evt.keyCode ? evt.keyCode : evt.which;

      if(keyCode < 48 || keyCode > 57){
        evt.preventDefault();
      }
    },
    calcularDig: function(evt){
      let value = evt.target.value;
      
      let z = value.length;
      let x = 0;
      let y = 0;
      let vpri = [];

      vpri[1] = 3;
      vpri[2] = 7;
      vpri[3] = 13;
      vpri[4] = 17;
      vpri[5] = 19;
      vpri[6] = 23;
      vpri[7] = 29;
      vpri[8] = 37;
      vpri[9] = 41;
      vpri[10] = 43;
      vpri[11] = 47;
      vpri[12] = 53;
      vpri[13] = 59;
      vpri[14] = 67;
      vpri[15] = 71;

      for(var i=0; i<z; i++){
          y = (value.toString().substr(i, 1));
          x += (y * vpri [z-i]);
      }

      y = x % 11;
      this.digitoVerificacion = (y > 1) ? 11 - y : y;
    },

    validarcc: function () {
      let resul = true
      let numbers = /^[-+]?[0-9]+$/;
      this.cedulaEmpresa = (''+this.cedulaEmpresa).match(numbers)
      if(isNaN(this.cedulaEmpresa)){
        resul = false
      }else{

      }
      return resul
    },
    registrar: function () {
      let resul = this.validardoc()
      if(!resul){
        this.$swal('Por favor revise el NIT de la empresa, debe ir solo numeros sin digito de verificación.')
        return false
      }
      resul = this.validarcc()
      if(!resul){
        this.$swal('Por favor revise la identificación del representante legal de la empresa, debe ir solo numeros.')
        return false
      }
      if(this.nombreEmpresa.toString().trim() == this.nitEmpresa.toString().trim()){
        this.$swal('Por favor revise el nombre de la empresa o NIT, no deben ser el mismo.')
        return false
      }
      if(this.nombreEmpresa.toString().trim() == (this.nitEmpresa.toString().trim()+''+this.digitoVerificacion)){
        this.$swal('Por favor revise el nombre de la empresa o NIT, no deben ser el mismo.')
        return false
      }
      this.nombreEmpresa = this.nombreEmpresa.toUpperCase()
      this.representanteEmpresa = this.representanteEmpresa.toUpperCase()
      let datos = {
        nombre: this.nombreEmpresa.trim(),
        identificacion: ''+this.nitEmpresa,
        tipo_proveedor: this.tipoEmpresa,
        representante_legal: this.representanteEmpresa.trim(),
        representante_legal_iden: ''+this.cedulaEmpresa,
        clave: this.claveEmpresa,
        email: this.emailEmpresa.trim()
      }
      this.$store.dispatch('registrar', datos).then(response => {
        if(response.CODE ==1){
          this.$swal("Registro exitoso, por favor ingresar al correo y activar la cuenta para poder ingresar al portal.")
          this.$router.push('/')
        }else{
          this.$swal("Falló el proceso de registro: "+response.MESSAGE+" vuelva a intentarlo")
        }
      })
    }
  }
}
</script>
